import { UtmTags } from './models/utm-tags';

export class UpdateUtmTags {
  static readonly type = '[Analytics] UpdateUtmTags';
  constructor(public payload: UtmTags) {}
}
export class ClearUtmTags {
  static readonly type = '[Analytics] ClearUtmTags';
}

export class TrackEvent {
  static readonly type = '[Analytics] Track Event';
  constructor(public payload: any) {}
}
